import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Col, Row, Card, Table } from "@themesberg/react-bootstrap";
import {
  confirmNumberTicket,
  getKenoResults,
} from "../../../../controller/api/gameResult";
import { useCookies } from "react-cookie";
import { TableRow } from "../component/TableRow";
import { calculatePage } from "../../../../helper/helper";
import Pagination from "../../../../components/Pagination";
import { Context } from "../Keno";
import CalculateRewardPopup from "../sub-screen/calculate-reward-popup/CalculateRewardPopup";
import ResultInputPopup from "../sub-screen/result-input-popup/ResultInputPopup";
import ResultEditPopup from "../sub-screen/result-edit-popup/ResultEditPopup";

const _Table = () => {
  const { state } = useContext(Context);

  const [cookies] = useCookies(["lottmekong"]);

  const [data, setData] = useState({});

  const [page, setPage] = useState(0);

  const oldPage = useRef(page);

  const oldFrom = useRef(state.from);
  const oldPeriod = useRef(state.period);

  const getAllFunc = useCallback(async () => {
    const response = await getKenoResults(
      cookies.lottmekong,
      {
        from: oldFrom.current,
        period: oldPeriod.current,
      },
      oldPage.current
    );

    if (response) {
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total),
      };
      setData(res || {});
    }
  }, [cookies.lottmekong]);

  const onConfirmNumberTicket = async (periodId, numberTicket) => {
    const response = await confirmNumberTicket(
      cookies.lottmekong,
      periodId,
      numberTicket
    );

    if (response) {
      const _newData = JSON.parse(JSON.stringify(data));

      _newData.list = _newData.list.map((it) => {
        if (it.gamePeriod.id === periodId) {
          it.totalTickets = numberTicket;
        }
        return {
          ...it,
        };
      });
      setData(_newData);
    }
  };

  const [modalCalculateRewardShow, setModalCalculateRewardShow] =
    useState(false);

  const [modalInputResultShow, setModalInputResultShow] = useState(false);

  const [modalEditResultShow, setModalEditResultShow] = useState(false);

  const gamePeriodRef = useRef(null);
  const resultRef = useRef(null);

  useEffect(() => {
    oldPage.current = page;
    getAllFunc();
  }, [page, getAllFunc]);

  useEffect(() => {
    oldFrom.current = state.from;
    oldPeriod.current = state.period;
    oldPage.current = 0;
    getAllFunc();
  }, [state.from, state.period, getAllFunc]);

  const onShowCalculateRewardPopupPress = (gamePeriod) => {
    gamePeriodRef.current = gamePeriod;
    setModalCalculateRewardShow(true);
  };

  const onShowInputResultPopupPress = (gamePeriod) => {
    gamePeriodRef.current = gamePeriod;
    setModalInputResultShow(true);
  };

  const onShowEditResultPopupPress = (gamePeriod, result) => {
    gamePeriodRef.current = gamePeriod;
    resultRef.current = result;
    setModalEditResultShow(true);
  };

  const onHideCalculateRewardPopupPress = (
    totalRewardTicket,
    totalUnrewardTicket,
    callback
  ) => {
    const _newData = JSON.parse(JSON.stringify(data));

    _newData.list = _newData.list.map((it) => {
      if (it.gamePeriod.id === gamePeriodRef.current.id) {
        it.totalRewaredTickets += totalRewardTicket;
        it.totalUnRewardTickets += totalUnrewardTicket;
      }
      return {
        ...it,
      };
    });
    setData(_newData);

    gamePeriodRef.current = null;

    callback();

    setModalCalculateRewardShow(false);
  };

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th scope="col">Tính thưởng</th>
              <th scope="col">Kỳ quay số</th>
              <th scope="col">Thống kê vé</th>
              <th scope="col">Kết quả quay số</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {data.list &&
              data.list.map((pv, index) => (
                <TableRow
                  onConfirmNumberTicket={onConfirmNumberTicket}
                  onInputResultPress={onShowInputResultPopupPress}
                  onEditResultPress={onShowEditResultPopupPress}
                  onCalculateRewardPress={onShowCalculateRewardPopupPress}
                  rIndex={index}
                  key={`result-status-${index}`}
                  {...pv}
                />
              ))}
          </tbody>
        </Table>
        <Card.Footer className="flex-row">
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage || 0}
                currentPage={oldPage.current || 0}
                onPageChange={(i) => {
                  setPage(i);
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <ResultInputPopup
        show={modalInputResultShow}
        period={gamePeriodRef.current}
        onHide={() => setModalInputResultShow(false)}
      />
      <ResultEditPopup
        show={modalEditResultShow}
        period={gamePeriodRef.current}
        result={resultRef.current}
        onHide={() => setModalEditResultShow(false)}
      />
      <CalculateRewardPopup
        show={modalCalculateRewardShow}
        period={gamePeriodRef.current}
        onHide={onHideCalculateRewardPopupPress}
      />
    </>
  );
};

export default React.memo(_Table);
